import React, { FC } from "react";

import "./index.scss";

interface Props {
  data?: {
    src?: string;
  };
}

export const ModalImagePreview: FC<Props> = ({ data }) => (
  <div className="modal-content-wrapper">
    <img src={data?.src} alt="preview" />
  </div>
);
